import { Stack } from "@mui/system";
import { Avatar, Box } from "@mui/material";

import CustomSocialButton from "./CustomSocialButton";
import { signInWithPopup, GoogleAuthProvider, getAdditionalUserInfo, deleteUser } from 'firebase/auth';
import toast from "react-hot-toast";
import { auth } from "../../firebaseConfig";
import { useRouter } from "next/router";
import { signInType } from "../../src/types/auth/auth";
import useLoginStore from "../../stores/loginStore";

const AuthSocialButtons = ({ title }: signInType) => {
  const router = useRouter();
  const { setIsLoading } = useLoginStore();

  const handleGoogleLogin = async () => {
    setIsLoading(true);
    const provider = new GoogleAuthProvider();
    try {
      const userCredential = await signInWithPopup(auth, provider);
      const isNewUser = getAdditionalUserInfo(userCredential).isNewUser;

      if (isNewUser) {
        const user = userCredential.user;
        await deleteUser(user);
        await auth.signOut();
        toast.error('Usuario no existente', { duration: 5000 });
      }
    } catch (error) {
      console.error('Error with Google login:', error);
      toast.error('Error al iniciar sesión con Google');
    } finally {
      setIsLoading(false);
    }
  };


  return (
    <>
      <Stack direction="row" justifyContent="center" spacing={2} mt={3}>
        <CustomSocialButton
          onClick={handleGoogleLogin}
        >
          <Avatar
            src={"/images/svgs/google-icon.svg"}
            alt={"icon1"}
            sx={{
              width: 16,
              height: 16,
              borderRadius: 0,
              mr: 1,
            }}
          />
          <Box
            sx={{
              display: { xs: "none", sm: "flex" },
              whiteSpace: "nowrap",
              mr: { sm: "3px" },
            }}
          >
            {title}{" "}
          </Box>{" "}
          Google
        </CustomSocialButton>
      </Stack>
    </>
  )
};

export default AuthSocialButtons;
